import React, { useEffect, useState } from "react";
import "../../../styles/desktop/detalhes.css";

const Detalhes = ({ evento, onClose }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false); // Estado para o pop-up

  return (
    <div className="detalhes-container">
      <div className="detalhes-header">
        <h2>Detalhes do Evento</h2>
        <button className="close-button-detalhes" onClick={onClose}>
          Voltar
        </button>
      </div>
      <div className="detalhes-content">
        <div className="detalhes-item">
          <strong>Nome:</strong> {evento.nome}
        </div>
        <div className="detalhes-item">
          <strong>Tipo:</strong> {evento.tipo}
        </div>
        <div className="detalhes-item">
          <strong>Descrição:</strong> {evento.descricao}
        </div>
        <div className="detalhes-item">
          <strong>IP Controlador:</strong> {evento.ip}
        </div>
        <div className="detalhes-item">
          <strong>Data:</strong> {evento.data}
        </div>
        <div className="detalhes-item">
          <strong>Hora:</strong> {evento.hora}
        </div>
        {evento.chamado_detalhes && (
          <div className="detalhes-item">
            <strong>Detalhes do Chamado:</strong> {JSON.stringify(evento.chamado_detalhes, null, 2)}
          </div>
        )}
      </div>
    </div>
  );
};

export default Detalhes;
